import React from "react";
import Grid from "@mui/material/Grid";
import { Box, Card } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import Typography from "@mui/material/Typography";
import { notEmpty } from "../../util/ext";

const useStyles = makeStyles(theme => ({
  root: {
    width: 305,
    height: "auto",
    backgroundColor: theme.palette.background.default,
    color: theme.palette.primary.main,
    borderRadius: 20,
    padding: 20,
  },

  h1: {
    fontSize: "3.6rem",
    lineHeight: "3.4rem",
    fontWeight: "bold",
    color: theme.palette.primary.main,
  },

  body1: {
    fontSize: "1.6rem",
    fontWeight: "bold",
    lineHeight: "2.2rem",
    color: theme.palette.primary.main,
  },

  body2: {
    fontSize: "1.3rem",
    lineHeight: "1.8rem",
    fontWeight: "normal",
    fontStyle: "italic",
    color: theme.palette.primary.main,
  },
}));

const ReportSummary = ({ primary, secondary, count, action }) => {
  const classes = useStyles();

  return (
    <Card classes={{ root: classes.root }}>
      <Grid
        container
        justifyContent="space-between"
        alignItems="center"
        style={{ height: "100%" }}
        spacing={2}
      >
        <Grid
          item
          md={true}
          style={{ maxWidth: 175, paddingTop: 10, paddingBottom: 10 }}
        >
          <Typography
            variant="body1"
            component="div"
            classes={{ body1: classes.body1 }}
          >
            {primary}
          </Typography>
          <Typography
            variant="body2"
            component="div"
            classes={{ body2: classes.body2 }}
          >
            {secondary}
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="h1" component="div" classes={{ h1: classes.h1 }}>
            {Number(count).toLocaleString()}
          </Typography>
        </Grid>
      </Grid>
      {notEmpty(action) && <Box>{action}</Box>}
    </Card>
  );
};

export default ReportSummary;
